<template>
  <div>
    <SummaryTitle title="Client"></SummaryTitle>
    <SummaryItem itemTitle="Business Entity Name">
      <template v-slot:content>
        {{ !!businessEntityName ? businessEntityName : 'Missing' }}
      </template>
    </SummaryItem>
    <SummaryItem itemTitle="Client Name">
      <template v-slot:content>
        {{ !!clientName ? clientName : 'Missing' }}
      </template>
    </SummaryItem>
    <SummaryItem itemTitle="Invoice Frequency">
      <template v-slot:content>
        {{ invoiceFrequency }}
      </template>
    </SummaryItem>
  </div>
</template>

<script>
import { SummaryTitle, SummaryItem } from '@/components/shared/display'
import getInvoicingFrequencyLabel from '@/lib/display/getInvoicingFrequencyLabel'

export default {
  components: {
    SummaryTitle,
    SummaryItem
  },
  props: ['clientName', 'invoiceFrequencyId', 'businessEntityName'],
  computed: {
    invoiceFrequency () {
      return this.invoiceFrequencyId ? getInvoicingFrequencyLabel(this.invoiceFrequencyId) : 'Missing'
    }
  }
}
</script>
